import React, { Component } from 'react';

class Map extends Component {
	render() {
		
		return (
			<div id='map' role='application' aria-label='Morganton Restaurant Map'></div>
		);
	}
}

export default Map;